import React from "react";
import { FileSignature, Download } from "lucide-react";
import { apiErr, API } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { toast } from "sonner";

export function ContractReviewBadge({ subId, signedBy, signedAt }) {
  const download = async () => {
    try {
      const token = localStorage.getItem("pte_token");
      const resp = await fetch(`${API}/form-submissions/${subId}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
      if (!resp.ok) throw new Error("Unable to download Contract Review PDF");
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `Contract-Review-${subId.slice(0, 6)}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) { toast.error(e.message || apiErr(e)); }
  };
  return (
    <div className="card pad" data-testid="job-contract-review"
      style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 12,
               background: "linear-gradient(135deg, #fff8e6, #fff)",
               border: "1px solid #e3d28a" }}>
      <div style={{ width: 36, height: 36, background: "#fff3cd", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", color: "#8a5a00" }}>
        <FileSignature size={18} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="t-strong" style={{ fontSize: 13.5 }}>Contract Review on file (CR-01)</div>
        <div className="s t-mut" style={{ fontSize: 12 }}>
          Signed by <strong>{signedBy || "customer"}</strong>
          {signedAt && <> · {fmtDate(signedAt)}</>}
          {" · ISO/IEC 17025 audit trail attached"}
        </div>
      </div>
      <button className="btn ghost sm" onClick={download} data-testid="job-cr-download">
        <Download size={13} /> Download PDF
      </button>
    </div>
  );
}
